import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail, MapPin } from "lucide-react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! We'll get back to you shortly.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to send message");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="contact-page" className="max-w-6xl mx-auto px-6 py-16">
      <div className="grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <p className="text-xs tracking-[0.3em] uppercase text-[#C86650] mb-2">Get in touch</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#1A2421] mb-4">Reach the Board.</h1>
          <p className="text-[#5C6A64] mb-10 leading-relaxed">
            Have a question, concern, or amenity request? Send us a note. We usually respond within two business days.
          </p>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-full bg-[#EADCC8] flex items-center justify-center flex-shrink-0">
                <Mail className="w-5 h-5 text-[#2C4C3B]" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-[#5C6A64] mb-1">Email</p>
                <p className="text-[#1A2421]">saddleridgesavoytrailshoa@gmail.com</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-full bg-[#EADCC8] flex items-center justify-center flex-shrink-0">
                <MapPin className="w-5 h-5 text-[#2C4C3B]" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-[#5C6A64] mb-1">Address</p>
                <p className="text-[#1A2421]">3983 E. Saddleridge Dr.<br />Stonecrest, GA</p>
              </div>
            </div>
          </div>
        </div>

        <form
          data-testid="contact-form"
          onSubmit={handleSubmit}
          className="lg:col-span-3 bg-white p-10 rounded-2xl border border-[#D5CFC4] shadow-[0_8px_30px_rgba(44,76,59,0.06)]"
        >
          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Name</label>
              <Input
                data-testid="contact-name"
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="mt-2 rounded-xl bg-white border-[#D5CFC4] h-11"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Email</label>
              <Input
                data-testid="contact-email"
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-2 rounded-xl bg-white border-[#D5CFC4] h-11"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Phone</label>
              <Input
                data-testid="contact-phone"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="mt-2 rounded-xl bg-white border-[#D5CFC4] h-11"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Subject</label>
              <Input
                data-testid="contact-subject"
                required
                value={form.subject}
                onChange={(e) => setForm({ ...form, subject: e.target.value })}
                className="mt-2 rounded-xl bg-white border-[#D5CFC4] h-11"
              />
            </div>
          </div>
          <div className="mt-5">
            <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Message</label>
            <Textarea
              data-testid="contact-message"
              rows={6}
              required
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="mt-2 rounded-xl bg-white border-[#D5CFC4]"
            />
          </div>
          <Button
            data-testid="contact-submit"
            disabled={submitting}
            type="submit"
            className="mt-8 rounded-full bg-[#C86650] hover:bg-[#B4553F] text-white h-12 px-8"
          >
            {submitting ? "Sending…" : "Send message"}
          </Button>
        </form>
      </div>
    </div>
  );
}
